module.exports = {"data":{"enteringCarnegieImage":{"sizes":{"aspectRatio":1.5,"src":"/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-36c73.jpg","srcSet":"/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-8dbfc.jpg 500w,\n/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-eed4f.jpg 1000w,\n/static/entering_carnegie-6d1ae8dd066952b5c85d20d5fc22d5fb-36c73.jpg 1500w","sizes":"(max-width: 1500px) 100vw, 1500px"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = 487
// module chunks = 273950069227526